const materialIconsMapper = false;

export default materialIconsMapper;
